/**
 * @file index.tsx
 * @deprecated Copied to app/modules/procurement/pages/master/index.tsx. This file still serves the existing /UProcure routes.
 * @module app/modules/uProcure/master/index
 * @description Implements the index interface for UProcure operations.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 2.1.2
 */

import React from "react";
import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import AllCategories from "./category/AllCategories";
import AddPrimaryCategories from "./category/add-primary-categories";
import AddSubCategories from "./category/add-sub-categories";
import AddGroupCategories from "./category/add-group-categories";
import EditPrimaryCategory from "./category/edit-primary-categories";
import EditSubCategories from "./category/edit-sub-categories";
import EditGroupCategories from "./category/edit-group-categories";
import Brands from "./brands/brands";
import AddBrand from "./brands/add-brand";
import EditBrand from "./brands/edit-brand";
import { PageLink, PageTitle } from "../../../../_admin/layout/core";
import ViewTechnicalDetails from "./technical-details/view-technical-details";
import AddTechnicalDetails from "./technical-details/add-technical-details";
import AddProductVariants from "./product-variants/add-product-variants";
import EditProductVariant from "./product-variants/edit-product-variants";
import ViewProductVariants2 from "./product-variants/view-product-variants";

const masterBreadCrumbs: Array<PageLink> = [
    {
        title: 'UProcure',
        path: '/UProcure',
        isSeparator: false,
        isActive: false,
    },
    {
        title: '',
        path: '',
        isSeparator: true,
        isActive: false,
    },
];

const UProcureMasterPage = () => (
    <>
        <Routes>
            <Route element={<Outlet />} >
                <Route
                    path="brands"
                    element={
                        <>
                            <PageTitle breadcrumbs={masterBreadCrumbs}>
                                Brands
                            </PageTitle>
                            <Brands />
                        </>
                    }
                />
                <Route
                    path="brands/add-brand"
                    element={
                        <>
                            <PageTitle breadcrumbs={masterBreadCrumbs}>
                                Add Brand
                            </PageTitle>
                            <AddBrand />
                        </>
                    }
                />
                <Route
                    path="brands/edit-brand"
                    element={
                        <>
                            <PageTitle breadcrumbs={masterBreadCrumbs}>
                                Edit Brands
                            </PageTitle>
                            <EditBrand />
                        </>
                    }
                />
                <Route
                    path="categories"
                    element={
                        <>
                            <PageTitle breadcrumbs={masterBreadCrumbs}>
                                Categories
                            </PageTitle>
                            <AllCategories />
                        </>
                    }
                />
                <Route
                    path="add-primary-categories"
                    element={
                        <>
                            <PageTitle breadcrumbs={masterBreadCrumbs}>
                                Add Primary Categories
                            </PageTitle>
                            <AddPrimaryCategories />
                        </>
                    }
                />
                <Route
                    path="edit-primary-categories"
                    element={
                        <>
                            <PageTitle breadcrumbs={masterBreadCrumbs}>
                                Edit Primary Categories
                            </PageTitle>
                            <EditPrimaryCategory />
                        </>
                    }
                />
                <Route
                    path="add-sub-categories"
                    element={
                        <>
                            <PageTitle breadcrumbs={masterBreadCrumbs}>
                                Add Sub Categories
                            </PageTitle>
                            <AddSubCategories />
                        </>
                    }
                />
                <Route
                    path="edit-sub-categories"
                    element={
                        <>
                            <PageTitle breadcrumbs={masterBreadCrumbs}>
                                Edit Sub Categories
                            </PageTitle>
                            <EditSubCategories />
                        </>
                    }
                />
                <Route
                    path="add-group-categories"
                    element={
                        <>
                            <PageTitle breadcrumbs={masterBreadCrumbs}>
                                Add Group Categories
                            </PageTitle>
                            <AddGroupCategories />
                        </>
                    }
                />
                <Route
                    path="edit-group-categories"
                    element={
                        <>
                            <PageTitle breadcrumbs={masterBreadCrumbs}>
                                Edit Group Categories
                            </PageTitle>
                            <EditGroupCategories />
                        </>
                    }
                />
                <Route
                    path="technical-details"
                    element={
                        <>
                            <PageTitle breadcrumbs={masterBreadCrumbs}>
                                Technical Details
                            </PageTitle>
                            <ViewTechnicalDetails />
                        </>
                    }
                />
                <Route
                    path="technical-details/add-technical-details"
                    element={
                        <>
                            <PageTitle breadcrumbs={masterBreadCrumbs}>
                                Add Technical Details
                            </PageTitle>
                            <AddTechnicalDetails />
                        </>
                    }
                />
                <Route
                    path="product-variants"
                    element={
                        <>
                            <PageTitle breadcrumbs={masterBreadCrumbs}>
                                Product Variants
                            </PageTitle>
                            <ViewProductVariants2 />
                        </>
                    }
                />
                <Route
                    path="product-variants/add-product-variants"
                    element={
                        <>
                            <PageTitle breadcrumbs={masterBreadCrumbs}>
                                Add Product Variants
                            </PageTitle>
                            <AddProductVariants />
                        </>
                    }
                />
                <Route
                    path="product-variants/edit-product-variants"
                    element={
                        <>
                            <PageTitle breadcrumbs={masterBreadCrumbs}>
                                Edit Product Variants</PageTitle>
                            <EditProductVariant />
                        </>
                    }
                />
                <Route path="*" element={<Navigate to="/error/404" />} />
            </Route>
        </Routes>
    </>
);

export default UProcureMasterPage;
